module.exports = {
	"recoverDecodingErrorDelay": 3000,
	"recoverSwapAudioCodecDelay": 3000,
	"abr": {
		"enabled": true,
		"restrictions": {}
	},
	"hlsConfig": {
		"fragLoadingMaxRetry": 4,
		"maxMaxBufferLength": 60
	}
};


//////////////////
// WEBPACK FOOTER
// ./default-config.json
// module id = 4
// module chunks = 0


// WEBPACK FOOTER //
// hls/default-config.json